import { render, staticRenderFns } from "./AverageTimeForm.vue?vue&type=template&id=3364c6da&"
import script from "./AverageTimeForm.vue?vue&type=script&lang=js&"
export * from "./AverageTimeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports